import React from 'react';
import styles from './ProductCard.module.scss';
import { Link } from 'react-router-dom';
import { IoStar } from 'react-icons/io5';

const BACKEND_URL = 'https://huongtramcomoc.vn'; 
const PLACEHOLDER_IMAGE = '/images/placeholder.jpg';

const ProductCard = ({ product }) => {
  // --- 1. LOGIC TÍNH GIÁ & GIẢM GIÁ ---
  const originalPrice = Number(product.price || 0);
  const salePrice = Number(product.sale_price || 0);
  
  // Logic: Có giảm giá khi sale_price hợp lệ và nhỏ hơn giá gốc
  const hasDiscount = salePrice > 0 && salePrice < originalPrice;
  const currentPrice = hasDiscount ? salePrice : originalPrice;
  const discountPercent = hasDiscount 
    ? Math.round(((originalPrice - salePrice) / originalPrice) * 100) 
    : 0;

  // Format tiền tệ VNĐ (Xử lý 0đ -> Liên hệ)
  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return "Liên hệ";
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
  };

  // --- 2. XỬ LÝ ẢNH ---
  const imageUrl = product.thumbnail_url 
    ? (product.thumbnail_url.startsWith('http') ? product.thumbnail_url : `${BACKEND_URL}${product.thumbnail_url}`)
    : PLACEHOLDER_IMAGE;

  // --- 3. LOGIC TAG (MỚI / HOT / GIẢM) ---
  const isNew = () => {
    if (!product.created_at) return false;
    const createdDate = new Date(product.created_at);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 30; // Mới trong 30 ngày
  };

  const isBestSeller = (product.sales_count || 0) > 10; 

  // --- 4. RENDER RATING ---
  const ratingValue = Number(product.rating) || 5; 

  return (
    <Link to={`/san-pham/${product.id}`} className={styles.productCard}>
      
      {/* --- IMAGE AREA --- */}
      <div className={styles.imageContainer}>
        
        {/* --- 3D RIBBON TAG --- */}
        <div className={styles.tagWrapper}>
          {hasDiscount ? (
              <div className={`${styles.ribbon} ${styles.ribbonDiscount}`}>
                Giảm {discountPercent}%
              </div>
          ) : isBestSeller ? (
              <div className={`${styles.ribbon} ${styles.ribbonHot}`}>
                Bán chạy
              </div>
          ) : isNew() ? (
              <div className={`${styles.ribbon} ${styles.ribbonNew}`}>
                Mới
              </div>
          ) : null}
        </div>

        <img src={imageUrl} alt={product.name} loading="lazy" />
        
        {/* Nút xem nhanh */}
        <div className={styles.overlayAction}>
           <button className={styles.btnQuickView}>Xem Chi Tiết</button>
        </div>
      </div>
      
      {/* --- INFO AREA --- */}
      <div className={styles.info}>
        <div className={styles.categoryName}>{product.category_name || 'Hương Trầm'}</div>
        
        <h3 className={styles.name} title={product.name}>
          {product.name}
        </h3>
        
        {/* Rating & Sold */}
        <div className={styles.metaRow}>
           <div className={styles.stars}>
              {[...Array(5)].map((_, i) => (
                <IoStar 
                  key={i} 
                  className={i < Math.round(ratingValue) ? styles.starFill : styles.starEmpty} 
                />
              ))}
           </div>
           <span className={styles.soldText}>Đã bán {product.sales_count || 0}</span>
        </div>

        {/* Price Block */}
        <div className={styles.priceContainer}>
            {/* Nếu giá = 0 (Liên hệ) thì dùng class riêng để chỉnh màu/size */}
            <span className={currentPrice === 0 ? styles.contactPrice : styles.currentPrice}>
              {formatCurrency(currentPrice)}
            </span>
            
            {hasDiscount && originalPrice > 0 && (
                <span className={styles.originalPrice}>
                  {formatCurrency(originalPrice)}
                </span>
            )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;